// extracted by mini-css-extract-plugin
export var arrowIcon = "Arrow-module--arrow-icon--fsS3j";
export var arrowIconCircle = "Arrow-module--arrow-icon-circle--3effj";
export var arrowIconFill = "Arrow-module--arrow-icon-fill--zF91c";
export var primary = "#06004d";
export var secondary = "#4dafd7";